import React from 'react';
import { FieldProps, useFieldHelper, BooleanField } from 'framework/ui/field';

const BusinessRulesViolatedField = ({ source, ...props }: FieldProps<any[]>) => {
  const { getValue } = useFieldHelper({ source });

  const rules = getValue();

  const areViolated = !!rules && !!rules.length;

  return <BooleanField {...props} value={areViolated} />;
};

export default BusinessRulesViolatedField;
